import { render } from "./ProjectMusic.vue?vue&type=template&id=27221c9f"
import script from "./ProjectMusic.vue?vue&type=script&lang=js"
export * from "./ProjectMusic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__